export default function submitFormHack({
  method,
  action = '',
  payload,
  skipSanitizationKeys = [],
}: {
  method: string;
  action?: string;
  payload?: { [key: string]: any };
  skipSanitizationKeys?: string[];
}) {
  const form = document.createElement('form');

  form.style.display = 'none';
  form.method = method;
  form.action = action;

  if (payload) {
    Object.entries(payload)
      .filter(([, value]) => value != null)
      .forEach(([name, value]) => {
        const input = document.createElement('input');
        input.name = sanitizeInput(name);
        input.value = skipSanitizationKeys.includes(name)
          ? String(value)
          : sanitizeInput(String(value));
        form.appendChild(input);
      });
  }

  document.body.appendChild(form);
  form.submit();
}

/**
 * This function takes an input string, assigns it to the textContent property of a newly created div,
 * and then returns the sanitized HTML content of the div. Since textContent does not parse HTML,
 * any harmful tags or scripts in the input will be treated as plain text, not as code.
 *
 * i.e.:
 * sanitizeInput("<script>window.alert('hi')</script>") -> "&lt;script&gt;window.alert('hi')&lt;/script&gt;"
 *
 * https://asecurityteam.atlassian.net/browse/VULN-1229071
 */
function sanitizeInput(input: string) {
  const div = document.createElement('div');
  div.textContent = input;
  return div.innerHTML;
}
